"use strict";

require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDeviceMotionIncludingGravity = exports.toDeviceMotion = exports.supportsDeviceMotion = exports.mkGenericDeviceMotion = void 0;
var _fromEvent = require("../Observables/fromEvent");
var _share = require("../Observables/share");
var _map = require("../Observables/map");
var supportsDeviceMotion = exports.supportsDeviceMotion = function supportsDeviceMotion() {
  return "ondevicemotion" in window;
};
var mkGenericDeviceMotion = exports.mkGenericDeviceMotion = function mkGenericDeviceMotion() {
  return (0, _fromEvent.fromEvent)(window, "devicemotion", true);
};
var toDeviceMotion = exports.toDeviceMotion = function toDeviceMotion(genericDeviceMotion$) {
  return genericDeviceMotion$.pipe((0, _share.share)(), (0, _map.map)(function (event) {
    return {
      x: event.acceleration.x,
      y: event.acceleration.y,
      z: event.acceleration.z,
      interval: event.interval
    };
  }));
};
var toDeviceMotionIncludingGravity = exports.toDeviceMotionIncludingGravity = function toDeviceMotionIncludingGravity(genericDeviceMotion$) {
  return genericDeviceMotion$.pipe((0, _share.share)(), (0, _map.map)(function (event) {
    return {
      x: event.accelerationIncludingGravity.x,
      y: event.accelerationIncludingGravity.y,
      z: event.accelerationIncludingGravity.z,
      interval: event.interval
    };
  }));
};